<template>
  <div class="cardContents">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="chart" ref="chart" />
  </div>
</template>

<script>
import { loadChart } from "../chart/chartData";
import { timerMixin } from "@/util/mixin/timerMixin";
import { get } from "@/api/index";
export default {
  mixins: [timerMixin],
  data() {
    return {
      typeList: ["基地", "品种"],
      active: 0
    };
  },
  mounted() {
    this.chart = this.$echarts.init(this.$refs.chart);
    window.addEventListener("resize", () => {
      this.chart.resize();
    });
    this.initChart();
    this.startTimer();
  },
  methods: {
    initChart() {
      let slist = [];
      let lineData = [];
      let unitlist = [];
      if (this.active === 0) {
        get("/api/restful/findZzjdList").then(res => {
          let data = res.data;
          data.map(item => {
            lineData.push(Number(item.area));
            unitlist.push("万亩");
            slist.push(item.name);
          });
          const xData = slist.reverse();
          const bfData = lineData.reverse();
          const unit = unitlist[this.active];
          loadChart(
            this.chart,
            xData,
            bfData,
            this.typeList[this.active],
            unit
          );
        });
      } else {
        get("/api/restful/zzjd/getPlantingScaleRanking", {
          type: this.typeList[this.active]
        }).then(res => {
          let data = res.data;
          data.map(item => {
            lineData.push(item.sum);
            unitlist.push(item.unit);
            slist.push(item.dataKindName);
          });
          const xData = slist.reverse();
          const bfData = lineData.reverse();
          const unit = unitlist[this.active];
          loadChart(
            this.chart,
            xData,
            bfData,
            this.typeList[this.active],
            unit
          );
        });
      }
    },

    runs() {
      let len = this.typeList.length;
      let active = Number(this.active);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeType(active, false);
    },
    changeType(index, clearT = true) {
      this.active = index;
      this.initChart();
      if (clearT) {
        this.startTimer();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContents
  height 100%
  position relative
  .tab-box
    position absolute
    top 10px
    right 4%
    z-index 999
    .tab-item
      color #fff
      font-size 10px
      padding-left 13px
      margin-right 20px
      position relative
      cursor pointer
      &:before
        content ' '
        // width 6px
        // height 6px
        width 12px
        height 12px
        border-radius 50%
        background #fff
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
    .active
      color #0e9cff
      &:before
        background #0e9cff
  .chart
    height 100%
</style>
